module.exports = __webpack_public_path__ + "static/media/4-13.c68e12be.png";